import type { PermissionLevel } from "../api/models/user.model";

/** Helper array that holds all of the permission levels that have edit access i.e. `'VIEW_AND_EDIT' | 'ADMIN' | 'SUPER_ADMIN'` */
export const EDIT_PERMISSION_LEVELS: PermissionLevel[] = ['VIEW_AND_EDIT', 'ADMIN', 'SUPER_ADMIN'] as const;